module.exports = __webpack_public_path__ + "static/media/rv1.85795300.jpg";